import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MemberListItem} from '../edit-guests.model';

@Component({
  selector: 'app-add-edit-guest',
  templateUrl: './add-edit-guest.component.html',
  styleUrls: ['./add-edit-guest.component.less']
})
export class AddEditGuestComponent implements OnInit {
  @Input() guest = null;
  @Output() closed = new EventEmitter();
  @Output() addGuest = new EventEmitter<any>();

  name = '';
  email = '';

  constructor() { }

  ngOnInit() {
    if (this.guest) {
      this.name = this.guest.guestName;
      this.email = this.guest.guestEmail;
    } else {
      this.guest = new MemberListItem();
    }
  }
  save() {
    this.guest.guestName = this.name;
    this.guest.guestEmail = this.email;
    if (this.guest.id) {
      this.close();
    } else {
      this.addGuest.emit(this.guest);
    }
  }
  close() {
    this.closed.emit();
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-database/edit-guests/add-edit-guest/add-edit-guest.component.ts